import Vue from 'vue'

export default Vue.extend({
  template: `
  <div>
    <div v-if="params.node.data.type === 'resource-texture'">Текстура</div>
    <div v-else-if="params.node.data.type === 'resource-audio'">Аудио</div>
    <div v-else-if="params.node.data.type === 'resource-tileset'">Тайлсет</div>
  </div>
  `,
  methods: {
  }
})
